import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=186902d4&scoped=true"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"
import style0 from "./TableColumn.vue?vue&type=style&index=0&id=186902d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186902d4",
  null
  
)

export default component.exports